import { useCallback, useState } from 'react';

//services
import { getExamQuestions } from 'services/sessions';

//interfaces
import { IExamWithQuestions } from 'services/interfaces/IExam';

export const useGetExamQuestions = () => {
  const [examQuestions, setExamQuestions] = useState<IExamWithQuestions | null>(null);

  const handleGetExamQuestions = useCallback(
    async (
      idBasis: string | number,
      idModule: string | number,
      idExam: string | number
    ) => {
      try {
        const resp = await getExamQuestions(idBasis, idModule, idExam);
        if (resp) setExamQuestions(resp);
      } catch (e) {
        console.log(e);
      }
    },
    []
  );

  return { examQuestions, handleGetExamQuestions };
};
